module.exports = __webpack_public_path__ + "static/media/settings.d118b364.svg";